<script>
    import { onMount } from 'svelte';

	import { ENGLISH, CANTONESE, PUTONGHUA } from './i18n/lang';
	import { zone_selected, code } from './store';

    import NSED_LOGO from "./components/logo_nsed.svelte";
	import AUDIO_GUIDE_LOGO from "./components/logo_audio_guide.svelte"
    // import TitleBar from "./components/title_bar.svelte";
    import ButtonRow from "./components/button__row.svelte";
    import LangButton from "./components/button_lang.svelte";
    import AudioPlayer from './components/audio_player.svelte';
    import OpenMapButton from './components/button_open_map.svelte';
	import OpenScannerButton from './components/button_open_scanner.svelte'
    import PinnedMapWrapper from './components/pinned_map__wrapper.svelte';
    import ZoneSelectModel from './components/model_zone_select.svelte';
	import AutoplaySetupModel from './components/model_autoplay_setup.svelte'
	import QRCodeScannerModel from './components/model_qrcode_scanner.svelte';
	import ZoneSelectModel3D from './components/model_zone_select_3D.svelte'

	let isLoading = true;
	let open = false;
	let hint_open = false;
	let qr_open = false;

	onMount(async() => {
		const urlParams = new URLSearchParams(window.location.search);
		let _code = urlParams.get('code')||'';
		if(_code != ''){
			$zone_selected = _code.slice(0,2).replace('Z0','Z1');
        	$code = _code.replace('Z0','Z1');
			gtag('event', 'ag_load', {
				'code': _code + '_C', // cantonese by default
			});
		}

		isLoading = false;
	});
</script>

{#if !isLoading}
<main>
	<div class="logo-wrapper">
		<NSED_LOGO/>
		<AUDIO_GUIDE_LOGO/>
	</div>
	<!-- <TitleBar/> -->

	<ButtonRow>
		<LangButton lang={CANTONESE}>廣東話</LangButton>
		<LangButton lang={PUTONGHUA}>普通話</LangButton>
		<LangButton lang={ENGLISH}>English</LangButton>
	</ButtonRow>

	<AudioPlayer/>

	<OpenMapButton _click={()=> open = true}/>

	<PinnedMapWrapper/>
	<OpenScannerButton _click={()=>{
		qr_open = true;
	}}/>
</main>
<!-- <ZoneSelectModel bind:open/> -->
 <ZoneSelectModel3D bind:open/>
<QRCodeScannerModel bind:open={qr_open}/>

<!-- <AutoplaySetupModel bind:open={hint_open}/> -->
{:else}
{/if}

<style lang='scss'>
	.logo-wrapper {
		position: relative;
		display: flex;
		flex-direction: column;
	}

	@media screen and (min-width:550px){
		.logo-wrapper {
			display: grid;
			grid-template-columns: 1fr 2fr 1fr;

			max-height: 22vh;
		}
	}
</style>